<footer class="footer">
  <div class="container-fluid">
    <div id="footer" class="row">
      <div class="col text-left">
        <span>&copy;Rare Technology Ltd.</span>
      </div>
      <div class="col text-right">
        <a class="privacy-policy" href="https://www.raretechnology.com/privacy-policy/" target="_blank">Privacy Policy</a>
        <span class="separator">|</span>
        <span class="terms-of-use">By using this site you agree to our
          <a [routerLink]="['/terms-of-use']" target="_blank">Terms of Use</a></span>
      </div>
    </div>
  </div>
</footer>
